import instance  from './axios'

//合同到期监控接口
export const contractMonitor=(para)=>{
  return instance.get('/contract/monitor',{params:para})
}
//合同列表接口
export const contractContractList=(para)=>{
  return instance.get('/contract/contractList',{params:para})
}
//获取公司列表
export const getCompanyList=(para)=>{
  return instance.get('/asset/getCompanyList',{params:para})
}
// 添加合同免租期
export const addOrModRentFree=(para)=>{
  return instance.post('/contract/addOrModRentFree',para)
}
// 删除合同免租期
export const removeRentFree=(para)=>{
  return instance.get('/contract/removeRentFree',{params:para})
}
// 获取合同免租期列表
export const rentFreeList=(para)=>{
  return instance.get('/contract/rentFreeList',{params:para})
}